import { useEffect } from 'react';

import { ensureNamespaces } from '../../i18n';
import LandingHeaderSection from './landingHeaderSection';
import LandingContactsSection from './landingContactsSection';
import LandingFooterSection from './landingFooterSection';
import { LandingPageRoot } from './landingPage.styles';

export default function SupportPage() {
  useEffect(() => {
    ensureNamespaces(['landing']);

    const scrollRoot = document.getElementById('app-scroll-root');
    if (scrollRoot) {
      scrollRoot.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <LandingPageRoot>
      <LandingHeaderSection anchorPrefix="/" />

      <LandingContactsSection />

      <LandingFooterSection />
    </LandingPageRoot>
  );
}
